( function() {
    window.addEventListener( 'DOMContentLoaded', () => {
        const skiplink = document.querySelector('a.skip-link');
        const main = document.querySelector('main#main');

        if (!skiplink || !main) {
            return;
        }

        skiplink.addEventListener('click', () => {
            skiplink.blur();
            main.focus();
        });
    } );
}() );


// WEBPACK FOOTER //
// ./scripts/custom/skip-link.js